import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from '../../breadcrumb.service';
import {Prediction} from '../../domain/prediction';
import {PredictionService} from '../../core/services/prediction-service';
import {ConfirmationService, MessageService} from 'primeng/api';
import {DataOpsService} from '../../core/services/data-ops-service';
import {saveAs} from 'file-saver';
import * as moment from 'moment';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-predictions',
    templateUrl: './predictions.component.html',
    styleUrls: ['./predictions.component.css'],
    providers: [MessageService, ConfirmationService]
})
export class PredictionsComponent implements OnInit {

    predictions: Prediction[];
    cols: any[];
    selectedPrediction: Prediction;
    prediction: Prediction = {};
    predictionDialog: boolean;
    submitted: boolean;
    defaultPageSize = 10;
    totalRecords: number;
    loading = false;
    sorting = 'lastModified,desc';
    currentPage = 0;
    filters = {};
    statuses: any[];
    statusesDesk: any[];
    statusesIce: any[];
    yesOrNo: any [];
    startDate: any;
    endDate: any;
    successRate: any;
    countInvoices: number;
    invoiceIds: number[];

    constructor(private predictionService: PredictionService,
                public breadcrumbService: BreadcrumbService,
                private messageService: MessageService,
                private confirmationService: ConfirmationService,
                private dataOpsService: DataOpsService) {
        this.breadcrumbService.setItems([
            {label: 'Predictions', routerLink: ['predictions']}
        ]);
    }

    ngOnInit(): void {

        this.cols = [
            {field: 'id', header: 'Id'},
            {field: 'invoiceId', header: 'Invoice ID'},
            {field: 'iceSupplierPredictedByIceExtractor', header: 'ICE Supplier'},
            {field: 'fiscalIdPredictedByExtractor', header: 'Fiscal Id'},
            {field: 'supplierTaxIdPredictedByExtractor', header: 'Supplier tax id'},
            {field: 'iceExtractorStatus', header: 'ICE Extractor status'},
            {field: 'deskewingInvoiceStatus', header: 'Deskewing Invoice Status'},
            {field: 'milouBlockStatus', header: 'Milou Block Status'},
            {field: 'voterStatus', header: 'Voter Status'},
            {field: 'invoiceStatus', header: 'Invoice Status'},
            {field: 'processed', header: 'Processed'}
        ];

        this.statuses = [
            {label: 'SUCCESS', value: 'SUCCESS'},
            {label: 'FAILED', value: 'FAILED'}
        ];

        this.statusesIce = [
            {label: 'SUCCESS', value: 'SUCCESS'},
            {label: 'FAILED', value: 'FAILED'},
            {label: 'ICE Not In Templates', value: 'ICE_NOT_IN_TEMPLATES'},
            {label: 'IF Not In Templates', value: 'IF_NOT_IN_TEMPLATES'}
        ];

        this.statusesDesk = [
            {label: 'SUCCESS', value: 'SUCCESS'},
            {label: 'FAILED', value: 'FAILED'},
            {label: 'NOT_DESKEWED', value: 'NOT_DESKEWED'}
        ];

        this.yesOrNo = [
            {label: 'Yes', value: 'Yes'},
            {label: 'No', value: 'No'}
        ];
    }

    onRowUnselect(event) {
        console.log('Unselected:' + event.data.id);
    }

    openNew() {
        this.prediction = new Prediction();
        this.submitted = false;
        this.predictionDialog = true;
    }

    hideDialog() {
        this.predictionDialog = false;
        this.submitted = false;
    }

    loadPredictions(event: any) {
        if (event.sortField) {
            this.sorting = event.sortField.concat(',').concat(event.sortOrder === 1 ? 'asc' : 'desc');
        }
        this.filters = event.filters;
        this.currentPage = event.first / 10;
        this.predictionService.getPredictions(this.currentPage, event.rows, this.filters, this.sorting, this.startDate, this.endDate)
            .subscribe(
                dataPaginated => {
                    this.totalRecords = dataPaginated.totalElements;
                    this.predictions = dataPaginated.content;
                    this.loading = false; // used to display loading dots in the UI
                },
                error => {
                    console.log('error fetching paginated data', error);
                }
            );

        this.predictionService.getPerformance(this.filters, this.startDate, this.endDate).subscribe(data => {
            if (data === 'NaN') {
                this.successRate = 0;
            } else {
                this.successRate = data;
            }
        });

        this.predictionService.countUniqueInvoices(this.filters, this.startDate, this.endDate).subscribe(data => {
            if (data === 'NaN') {
                this.countInvoices = 0;
            } else {
                this.countInvoices = data;
            }
        });

        this.dataOpsService.getInvoiceIdsFromAPI(this.filters, this.startDate, this.endDate).subscribe(value => this.invoiceIds = value);
    }

    initPredictions() {
        this.predictionDialog = false;
        this.prediction = new Prediction();
        this.getPredictions();
    }

    onSearch() {
        this.getPredictions();
    }

    private getPredictions() {
        this.predictionService.getPredictions(this.currentPage, this.defaultPageSize, this.filters, this.sorting, this.startDate, this.endDate).subscribe(data => {
            this.predictions = data.content;
            this.totalRecords = data.totalElements;
        });

        this.predictionService.getPerformance(this.filters, this.startDate, this.endDate).subscribe(data => {
            if (data === 'NaN') {
                this.successRate = 0;
            } else {
                this.successRate = data;
            }
        });

        this.predictionService.countUniqueInvoices(this.filters, this.startDate, this.endDate).subscribe(data => {
            if (data === 'NaN') {
                this.countInvoices = 0;
            } else {
                this.countInvoices = data;
            }
        });

        this.dataOpsService.getInvoiceIdsFromAPI(this.filters, this.startDate, this.endDate).subscribe(value => this.invoiceIds = value);
    }

    savePrediction() {
        this.submitted = true;
        if (this.prediction.id) {
            this.predictionService.updatePrediction(this.prediction)
                .subscribe(() => {
                    this.initPredictions();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Prediction Updated',
                        life: 3000
                    });
                }, error => {
                    console.log(error);
                });
        } else {
            this.predictionService.savePrediction(this.prediction)
                .subscribe(() => {
                    this.initPredictions();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Prediction Added',
                        life: 3000
                    });
                }, error => {
                    console.log(error);
                });
        }
    }

    editPrediction(prediction: Prediction) {
        this.prediction = {...prediction};
        this.predictionDialog = true;
    }

    deletePrediction(prediction: Prediction) {
        console.log(prediction);
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the prediction with Id:' + prediction.id + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.predictionService.deletePrediction(prediction).subscribe(
                    () => {
                        this.initPredictions();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Prediction Deleted',
                            life: 3000
                        });
                    }
                );
            }
        });
    }

    onDownload() {
        this.loading = true;
        if (this.totalRecords > 0) {
            this.dataOpsService.getAttachedDocuments(this.invoiceIds).subscribe(
                (data: any) => {
                    const file = new Blob([data], {type: 'text/csv;charset=utf-8'});
                    const date = moment(new Date()).format('YYYY-MM-DD').toString();
                    saveAs(file, 'dataops-'.concat(date).concat('.zip'));
                    this.loading = false;
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 400) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'Download limit of 100 exceeded, you asked for ' + this.totalRecords,
                            life: 5000
                        });
                    } else if (error.status === 404) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'No file Found for this list of prediction',
                            life: 5000
                        });
                    } else {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'An error occurred while downloading the data',
                            life: 5000
                        });
                    }

                    this.loading = false;
                });
        } else {
            this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Cannot download data of an empty prediction list',
                life: 5000
            });
            this.loading = false;
        }
    }

    downloadPdfs() {
        this.loading = true;
        if (this.totalRecords > 0) {
            this.dataOpsService.getPdfsBundle(this.invoiceIds).subscribe(
                (data: any) => {
                    const file = new Blob([data], {type: 'application/zip'});
                    const date = moment(new Date()).format('YYYY-MM-DD').toString();
                    saveAs(file, 'dataops-'.concat(date).concat('.zip'));
                    this.loading = false;
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 400) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'Download limit of 100 exceeded, you asked for ' + this.totalRecords,
                            life: 5000
                        });
                    } else if (error.status === 404) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'No file Found for this list of predictions',
                            life: 5000
                        });
                    } else {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'An error occurred while downloading the data',
                            life: 5000
                        });
                    }

                    this.loading = false;
                });
        } else {
            this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Cannot download data of an empty prediction list',
                life: 5000
            });
            this.loading = false;
        }
    }

    exportPredictions() {
        if (this.invoiceIds.length > 1000) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Cannot export more than 1000 predictions',
                life: 5000
            });
        }
        this.predictionService
            .exportPredictions(this.invoiceIds)
            .subscribe((data: any) => {
                const file = new Blob([data], {type: 'text/csv;charset=utf-8'});
                const date = moment(new Date()).format('YYYY-MM-DD').toString();
                saveAs(file, 'export_prediction-'.concat(date).concat('.csv'));
            });
    }
}

